(function () {
    "use strict";

    angular.module("app").directive("validateReferenceNumber", ValidateReferenceNumberAttribute);

    ValidateReferenceNumberAttribute.$inject = ["$parse",];
    function ValidateReferenceNumberAttribute($parse) {
        return {
            require: "ngModel",
            restrict: "A",
            link: function (_scope, _element, _attrs, ctrl) {

                ctrl.$validators.invalidReferencenumber = function (_modelValue, viewValue) {

                    if (!shouldValidate())
                        return true;

                    const result = habilCommon.isValidPersonNumber(viewValue, true);
                    // TODO: Warning

                    ctrl.$warnings = result.warnings;

                    return result.isValid;
                };

                function shouldValidate() {
                    const parameter = _attrs.validateReferenceNumber;
                    if (!angular.isString(parameter) || parameter.length === 0)
                        return true;

                    return $parse(_attrs.validateReferenceNumber)(_scope);
                }
            }
        };
    }
})();